<template>
  <section class="section -center">
    <h2 class="section__title" v-reveal>{{ title }}</h2>
    <p class="section__text" v-reveal="{ delay: 200 }">
      {{ subtitle }}
    </p>

    <div class="partners">
      <div class="partners__tabs" v-reveal>
        <button
          class="partners__tabs-tab"
          :class="{ '-active': tab === key }"
          v-for="(partner, key) in partners"
          :key="key"
          @click="tab = key"
        >
          {{ partner.label }}
        </button>
      </div>

      <div class="partners__logos" v-reveal>
        <transition name="fade" mode="out-in">
          <div :key="tab" class="partners__logos">
            <div
              v-for="partner in partners[tab].partners"
              :key="partner.id"
              class="partners__logos-logo"
              :style="{ backgroundImage: `url(${partner.logo.original})` }"
              @click="goToPartnerWebsite(partner)"
            />
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionPartners',
  props: {
    title: {
      type: String,
      default: 'NOS PARTENAIRES',
    },
    subtitle: {
      type: String,
      default: 'Lorem ipsum',
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 0,
    }
  },
  computed: {
    partners() {
      let data = []
      this.groups.forEach((group) => {
        data.push({
          label: group.name,
          partners: group.partners_ids.map((partnerId) => this.$beet.partners[Number(partnerId)]),
        })
      })
      return data
    },
  },
  methods: {
    goToPartnerWebsite(partner) {
      window.open(partner.website, '_blank')
    },
  },
}
</script>
